import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken } from '@nebular/auth';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { LightboxModule } from 'ngx-lightbox';

import { AuthGuardProvider } from './providers/auth-guard.provider';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { JwtInterceptorProvider } from './providers/jwt-interceptor.provider';
import { environment } from '../environments/environment';
import { NbRestoreScrollTopHelper } from '@nebular/theme';
import { NbScrollTopPatchProvider } from './providers/nb-scroll-top-patch.provider';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: environment.apiUrl,
          token: {
            class: NbAuthJWTToken,
            key: 'accessToken',
          },
          login: {
            endpoint: '/v1/user/login-dashboard',
            method: 'post',
            redirect: {
              success: 'pages',
            }
          }
        }),
      ],
      forms: {},
    }),
    LightboxModule
  ],
  providers:[
    AuthGuardProvider,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorProvider, multi: true },
    { provide: NbRestoreScrollTopHelper, useClass: NbScrollTopPatchProvider },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorProvider, multi: true  },
  ],
  exports:[],
  bootstrap: [AppComponent],
})
export class AppModule {
}
